import { useEffect, useState } from 'react';
import { FileField } from '../../../components/field/field';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { toast } from '../../../util/toasts';
import { ProductImageV2 } from '../../../components/image/product/product-image-v2';
import { Spinner } from '../../../components/spinner/spinner';

export const ProductPlaceholder = () => {
  const { uploadToS3, getUploadProductPlaceholderImageUrl, uploadResizedPlaceholderImages } = useAPI();
  const [placeholderImage, setPlaceholderImage] = useState<File>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [profile, setProfile] = useState<'MINI' | 'THUMB' | 'MEDIUM' | 'APP' | 'LARGE' | 'ORIGINAL' | undefined>(
    'LARGE',
  );

  const uploadPlaceholder = async () => {
    if (placeholderImage) {
      try {
        setIsLoading(true);
        const url = await getUploadProductPlaceholderImageUrl(placeholderImage.name);
        await uploadToS3(url, placeholderImage);
        setPlaceholderImage(undefined);
        await uploadResizedPlaceholderImages();
        toast('Product placeholder image uploaded successfully', 'success');
        setIsLoading(false);
        setProfile('ORIGINAL');
      } catch (e) {
        toast('Failed to upload product placeholder image', 'error');
      }
    }
  };

  useEffect(() => {
    uploadPlaceholder();
  }, [placeholderImage]);

  return isLoading ? (
    <Spinner />
  ) : (
    <div>
      <FileField
        onChange={(f) => setPlaceholderImage(f as File)}
        multiple={false}
        accept="image/jpeg, image/png"
        value={placeholderImage}
      />
      <br />
      <br />
      <div className="p-2 bg-gray-300 w-fit">
        <ProductImageV2 className="w-fit" productId={isLoading ? 0 : 'placeholder'} profile={profile} />
      </div>
      <br />
      <br />
      Preferred dimensions 172 X 55
    </div>
  );
};
